function SectionRow({

    title,

    right

}){

    return(

        <div
            style={{

                display:"flex",

                justifyContent:"space-between",

                alignItems:"center",

                marginBottom:"15px"

            }}
        >

            <span>{title}</span>

            {right}

        </div>

    );

}

export default SectionRow;